import { isPCEOrGov } from '../../../util/environments';
import { isFlex } from '../../../util/flex';
import { Resource } from '@mulesoft/monitoring-center-components/lib/models/resource';

/**
 * util to check if the link to switch between basic and enhanced metrics must be shown
 * @param isApiAnalyticsBuiltInDashboardDisabled - API_ANALYTICS_BUILT_IN_DASHBOARD_DISABLED feature flag
 * @param apiMetricsCompatible
 * @param isApi
 */
export const shouldShowApiSwitch = (isApiAnalyticsBuiltInDashboardDisabled: boolean,
                                    apiMetricsCompatible: boolean = false,
                                    isApi: boolean = false) =>
        !isApiAnalyticsBuiltInDashboardDisabled && apiMetricsCompatible && isApi

/**
 * util to check if enhanced view or basic view must be shown
 * @param isApiAnalyticsBuiltInDashboardDisabled  - API_ANALYTICS_BUILT_IN_DASHBOARD_DISABLED feature flag
 * @param resource
 * @param isHTTPMetricsCompatible
 * @param isHTTPMetricsEnabled
 * @param apiMetricsView
 */
export const shouldShowEnhancedViewOfAnalyticsDashboard = (isApiAnalyticsBuiltInDashboardDisabled: boolean, resource: Resource,
                                                           isHTTPMetricsEnabled: boolean, isHTTPMetricsCompatible: boolean = false,
                                                           apiMetricsView: boolean = false) =>
        isApiAnalyticsBuiltInDashboardDisabled || isPCEOrGov() || isFlex(resource) || (isHTTPMetricsEnabled && isHTTPMetricsCompatible && apiMetricsView)
